'use strict';

var styled = require('styled-components');
var component = require('../../Icon/component.js');
require('react');
require('../../Tooltip/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const IconStyled = styled__default.default(component.Icon) `
  ${({ onMouseDown }) => (onMouseDown ? 'cursor: pointer;' : null)}
`;

exports.IconStyled = IconStyled;
//# sourceMappingURL=cellIcon.styles.js.map
